// apps/web/src/features/agent/artifacts/ArtifactRenderer.tsx (#1877)
//
// Dispatches a streamed `Artifact` to its per-kind card. Any unknown future kind
// is routed to a plain-text unsupported notice — this renderer must NEVER throw
// on an unexpected kind.
//
// INVARIANT (XSS): the whole artifacts feature renders model-supplied strings
// ONLY inside JSX text nodes. FORBIDDEN here and in every child:
// `dangerouslySetInnerHTML`, markdown/HTML parsers, any string→HTML
// conversion. A value containing `<script>` or `<img onerror=…>` MUST appear
// as literal text. Do not weaken this without an ADR.
import { useTranslation } from 'react-i18next';
import type { AgentRenderableArtifact } from '@magimp/shared';
import { ChartArtifactCard } from './ChartArtifactCard.js';
import { KpiArtifactCard } from './KpiArtifactCard.js';
import { TableArtifactCard } from './TableArtifactCard.js';
import { TextArtifactCard } from './TextArtifactCard.js';

function UnsupportedNotice() {
  const { t } = useTranslation('agent');
  return <div style={{ fontSize: 13, color: 'var(--fg-3)' }}>{t('artifacts.unsupported')}</div>;
}

export function ArtifactRenderer({ artifact }: { artifact: AgentRenderableArtifact }) {
  switch (artifact.kind) {
    case 'kpi':
      return <KpiArtifactCard artifact={artifact} />;
    case 'table':
      return <TableArtifactCard artifact={artifact} />;
    case 'text':
      return <TextArtifactCard artifact={artifact} />;
    case 'chart':
      return <ChartArtifactCard artifact={artifact} />;
    default:
      return <UnsupportedNotice />;
  }
}
